module.exports = __webpack_public_path__ + "img/arrowSort.a061412f.svg";